import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class WCSubCategoriesQueryService {

    public GET_SUBCATEGORIES: any;
    public GET_LAST_SUB_CATEGORY: any;
    public CREATE_WC_SUB_CATEGORY: any;
    public GET_ALL_SUBCATEGORIES_BY_CATEGORYID: any;

    constructor(public apollo: Apollo) {

        this.GET_SUBCATEGORIES =
            gql`
                query getSubcategories{                           
                    allWcSubcategories {
                    edges {
                        node {
                            subCategory
                            categoryid
                            subId
                        }
                    }
                    }
                }
            `
            ;

        this.GET_LAST_SUB_CATEGORY =
            gql`
                query getLastSubCategory{
                    allWcSubcategories(last:1) {
                         edges {
                            node {
                                subId
                            }
                         }
                    }
                }
             `;

        this.CREATE_WC_SUB_CATEGORY =
            gql`
            mutation createWcSubCategory($input:CreateWcsubcategoryInput!){
                createWcsubcategory(input:$input){
                        wcsubcategoryEdge  {
                                node{
                                   subid
                                   subcategory
                                   categoryid
                                  createdat
                                    }
                        }  
                }
            }
        `;

        this.GET_ALL_SUBCATEGORIES_BY_CATEGORYID =
            gql`
            query getSubcategories($categoryid:Int){                           
                allWcsubcategories ( condition: {categoryid: $categoryid} ) {
                    nodes{
                        categoryid
                        subid
                        subcategory
                         }
                }
            }
        `;
    }

    /** Get all wc sub categories - Walk talk & Walk Call */

    GET_WC_SUB_CATEGORIES() {
        return this.apollo
            .watchQuery({
                query: this.GET_SUBCATEGORIES
                ,
                fetchPolicy: 'network-only'
            });
    }

    /**Get last sub category Id */

    GET_LAST_WC_SUB_CATEGORY_ID() {

        return this.apollo
            .watchQuery({
                query: this.GET_LAST_SUB_CATEGORY
                ,
                fetchPolicy: 'network-only'
            });
    }

    /** Create wc sub categories - Walk talk & Walk Call */

    CREATE_WC_SUB_CATEGORIES(params) {
       
        return this.apollo.mutate({
            mutation: this.CREATE_WC_SUB_CATEGORY,
            variables: {
                "input": {
                    "wcsubcategory": {
                        "subcategory": params.subcategory,
                        "categoryid": params.categoryid,
                        "createdat": new Date(),
                    }
                },
            },
        })
    }

    /** Get All sub categories By CategoryId Of Primary Category */
    GET_ALL_SUB_CATEGORIES_BY_CATEGORYID(categoryIdOfPrimaryCategory) {
        return this.apollo.watchQuery({
            query: this.GET_ALL_SUBCATEGORIES_BY_CATEGORYID,
            variables:
            {
                categoryid: categoryIdOfPrimaryCategory,
            },
            fetchPolicy: 'network-only'
        })

    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/wcSubCategories.ts